<div class="blogs-page-wrapper py-4">
    @for (row of sectionsRows(); track $index) {
        @if (row.length > 0) {
            @if (row[0].section_type === 'title') {
                <div class="blogs-hero text-center mb-5 p-4 p-md-5 rounded-4 shadow-sm position-relative overflow-hidden">
                    <div class="hero-bg-glow"></div>
                    <span class="hero-badge badge px-3 py-2 rounded-pill mb-3">Articles & Guides</span>
                    <h1 class="display-5 fw-bold mb-3 blogs-page-title">
                        {{ getCleanContent(row[0].content) || 'Our Blog' }}
                    </h1>
                    <div class="hero-divider mx-auto"></div>
                </div>
            } @else {
                <div class="row mb-4 justify-content-center">
                    @for (item of row; track $index) {
                        @if (getCleanContent(item.content).length > 0) {
                            <div [innerHTML]="getCleanContent(item.content)" [class]="'col-md-'+(12/row.length)" class="blogs-intro-content text-muted mb-3"></div>
                        }
                    }
                </div>
            }
        }
    }

    @if (children() && children().length > 0) {
        <div class="blogs-flex-container d-flex flex-wrap gap-4 justify-content-center my-4">
            @for (child of children(); track child.id) {
                <div class="blog-card-wrapper d-flex">
                    <div class="blog-card d-flex flex-column bg-white rounded-4 shadow-sm overflow-hidden border border-light-subtle w-100">
                        <a [routerLink]="getRouterLink(child)" class="blog-card-img-link position-relative overflow-hidden d-block">
                            <img [src]="getFeaturedImage(child)" [alt]="getTitle(child)" class="blog-card-img w-100" loading="lazy">
                            <span class="badge blog-card-badge position-absolute top-0 end-0 m-3 px-3 py-2 rounded-pill shadow-sm">Article</span>
                        </a>
                        <div class="blog-card-body d-flex flex-column flex-grow-1 p-4">
                            @if (getDate(child)) {
                                <div class="blog-card-meta text-muted small mb-2 d-flex align-items-center">
                                    <i class="bi bi-calendar3 me-2 text-primary"></i>
                                    <span>{{ getDate(child) }}</span>
                                </div>
                            }
                            <h3 class="blog-card-title fw-bold mb-3">
                                <a [routerLink]="getRouterLink(child)" class="text-decoration-none text-dark">{{ getTitle(child) }}</a>
                            </h3>
                            <p class="blog-card-desc text-secondary mb-4 flex-grow-1">
                                {{ getDescription(child) }}
                            </p>
                            <div class="mt-auto pt-3 border-top border-light">
                                <a [routerLink]="getRouterLink(child)" class="btn btn-outline-primary blog-read-more-btn px-4 py-2 rounded-pill fw-semibold d-inline-flex align-items-center">
                                    <span>Read More</span>
                                    <i class="bi bi-arrow-right ms-2 transition-icon"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div class="text-center py-5 my-5 blogs-empty-state">
            <i class="bi bi-journal-text display-3 text-muted mb-3 d-block"></i>
            <h4 class="fw-bold text-secondary">No Blog Articles Yet</h4>
            <p class="text-muted">Check back soon for new legal guides and updates.</p>
        </div>
    }
</div>
